export default "__VITE_PUBLIC_ASSET__4728f39c__"